module.exports = __webpack_public_path__ + "img/maintop.483ba82.png";